// extracted by mini-css-extract-plugin
module.exports = {"container":"Gi-z","list":"Hi-z"};